import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import {
  UserData,
  Response,
  QueryRequest,
  LocalStorageKeys,
  PreferenceRequest,
  PreferenceResponse,
  ContentType,
  UserPasswordRequest,
  PasswordResponse,
  UserSession,
  UserLanguageRequest,
  UserPinRequest,
  PinResponse,
  CreateUserPinRequest,
  CodeUserPinRequest,
} from '@models/index.model';
import { UtilsService } from '@services/index.service';

@Injectable()
export class UserPinService {
  private UrlAPI = environment.apiUrl;
  private UrlAuthAPI = environment.apiAuthUrl;

  constructor(private http: HttpClient, private _utils: UtilsService) {}

  // API METHODS.
  public createUserPin(pinRequest: CreateUserPinRequest | CodeUserPinRequest): Observable<Response<PinResponse>> {
    const query = this.UrlAPI + QueryRequest.userPin;
    const httpHeaders = new HttpHeaders({ 'user-pin': 'createUserPin' });
    const options = { headers: httpHeaders };
    return this.http.post<Response<PinResponse>>(query, this._utils.stringifyData(pinRequest), options);
  }

  public sendEmailCode(): Observable<Response<boolean>> {
    const query = this.UrlAPI + QueryRequest.userPinCode;
    const httpHeaders = new HttpHeaders({ 'user-pin': 'sendPinCode' });
    const options = { headers: httpHeaders };
    return this.http.post<Response<boolean>>(query, null, options);
  }
}
